<template>
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs}">
      <v-btn
        small
        class="info mr-4"
        v-bind="attrs"
        v-on="on"
        @click="$router.push({name: 'AdministratorUserNotificationAdd'})"
      >
        <v-icon left small>mdi-note-edit</v-icon>
        {{ $t("newMessage") }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense>
        {{ $route.meta.nameDrawer }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-form class="form-notification">
        <v-card-text class="grey--text text--lighten-1">
          {{ $t("addNotificationText") }}
        </v-card-text>
        <AutocompletePlayers
          style="padding: 16px"
          :clearAutocomplete="clearAutocomplete"
        />

        <v-card-text class="pb-0">
          <v-expansion-panels
            v-model="seeUsersId"
            :disabled="usersId.length == 0"
            class="mb-4"
            flat
            outlined
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row no-gutters class="d-flex align-center">
                  <v-col>
                    <span>{{ $t("seeSelectedUsers") }} ({{ uniqueUsersId.length }})</span>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="float-right mr-3"
                      small
                      :disabled="usersId.length == 0"
                      @click="clearIds"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <span v-if="uniqueUsersId.length == 0">{{ $t("all") }}</span>
                <div v-else class="d-flex flex-wrap" style="gap: 12px">
                  <v-chip small v-for="id in uniqueUsersId" :key="id">
                    {{ id }}
                  </v-chip>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-textarea
            v-model="message"
            height="auto"
            maxLength="500"
            outlined
            hide-details
          ></v-textarea>
          <div class="caption text-right grey--text">
            <strong>{{ message.length }} / 500</strong>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            class="info"
            :loading="sendingMessage"
            :disabled="message.length == 0 || sendingMessage"
            @click="addNotification()"
          >
            {{ $t("toSend") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import AutocompletePlayers from "@/components/common/filters/AutocompletePlayers";
export default {
  name: "administrator-dashboard-notification-new",
  components: {
    AutocompletePlayers,
  },
  data: () => ({
    message: "",
    usersId: [],
    uniqueUsersId: [],
    seeUsersId: [],
    dialog: false,
    disabled: false,
    sendingMessage: false,
    clearAutocomplete: false,
    rules: [v => (v.length <= 5) || 'atingiu o máximo de caracteres'],
  }),

  computed: {
    autocompletePlayers() {
      return this.$store.state.filters.autocompletePlayers.id;
    },
  },

  mounted() {
    this.clearIds();
  },

  watch: {
    autocompletePlayers(val) {
      val && this.usersId.push(val);
    },
    usersId() {
      this.handleUsersIdsToUniqueValues();
    },
  },

  methods: {
    clearIds() {
      this.usersId = [];
      this.uniqueUsersId = [];
    },

    handleUsersIdsToUniqueValues() {
      this.uniqueUsersId = [...new Set(this.usersId)];
    },

    addNotification() {
      this.sendingMessage = true;

      const body = {
        id_usuarios: this.uniqueUsersId,
        descricao: this.message,
      }

      this.$axios
        .post(`${this.$prefix()}/notifications/addNotification`, body)
        .then((resp) => {
          this.sendingMessage = false;

          this.$store.commit("setFeedbackSnack", {
            msg: resp.data.messages,
            color: "success",
          });
          this.$emit("fetchNotificationsList", true);

          // mandamos clearAutocomplete como prop pro AutocompletePlayers
          // para limpar o input internamente
          this.clearAutocomplete = true;
          this.closeDialog();
          this.clearIds();
        })
        .catch(() => {
          this.sendingMessage = false;
        })
    },

    closeDialog() {
      this.resetInput()
      this.$store.commit("setPlayerId", "");
      this.clearAutocomplete = true;
      this.dialog = false;
      this.$router.go(-1);
    },

    resetInput() {
      this.message = "";
    }
  },
};
</script>

<style>
.form-notification textarea[disabled="disabled"] {
  color: #fff;
}

.form-notification p {
  min-height: 500px;
  color: #fff;
}

.form-notification .v-text-field__details {
  display: none;
}
</style>
